import { render, staticRenderFns } from "./DemjanSandorProgram.vue?vue&type=template&id=32d5db22&scoped=true"
import script from "./DemjanSandorProgram.vue?vue&type=script&lang=js"
export * from "./DemjanSandorProgram.vue?vue&type=script&lang=js"
import style0 from "./DemjanSandorProgram.vue?vue&type=style&index=0&id=32d5db22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d5db22",
  null
  
)

export default component.exports